export const SPORT_CONFIG = {
    trending: {
        title: "🔥 Trending News",
        badge: "bg-red-600",
        hover: "group-hover:text-red-600",
        label: "Trending",
    },
    breaking: {
        title: "🚨 Breaking News",
        badge: "bg-red-600",
        hover: "group-hover:text-red-600",
        label: "Breaking",
    },
    cricket: {
        title: "🏏 Cricket News",
        badge: "bg-green-700",
        hover: "group-hover:text-green-700",
        label: "Cricket",
    },
    football: {
        title: "⚽ Football News",
        badge: "bg-emerald-700",
        hover: "group-hover:text-emerald-700",
        label: "Football",
    },
    tennis: {
        title: "🎾 Tennis News",
        badge: "bg-lime-700",
        hover: "group-hover:text-lime-700",
        label: "Tennis",
    },
    basketball: {
        title: "🏀 Basketball News",
        badge: "bg-orange-600",
        hover: "group-hover:text-orange-600",
        label: "Basketball",
    },
    hockey: {
        title: "🏑 Hockey News",
        badge: "bg-blue-700",
        hover: "group-hover:text-blue-700",
        label: "Hockey",
    },
    olympics: {
        title: "🏅 Olympics News",
        badge: "bg-amber-600",
        hover: "group-hover:text-amber-600",
        label: "Olympics",
    },
};
